import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Alert, Input, Modal } from 'antd'
import { PortalPillarIndexEntry } from '../helpers/anchor-utils'

interface PillarIndexContentModalProps {
  open: boolean
  entries: PortalPillarIndexEntry[]
  labels?: Record<string, string>
  onCancel: () => void
  onApply: (labels: Record<string, string>) => void
}

export function PillarIndexContentModal({
  open,
  entries,
  labels,
  onCancel,
  onApply,
}: PillarIndexContentModalProps): React.ReactElement {
  const [draft, setDraft] = useState<Record<string, string>>({})

  useEffect(() => {
    if (!open) return
    setDraft(
      entries.reduce<Record<string, string>>((values, entry) => {
        if (entry.isIntroduction) return values
        values[entry.key] = Object.prototype.hasOwnProperty.call(labels || {}, entry.key)
          ? labels?.[entry.key] || ''
          : entry.title.slice(0, 35)
        return values
      }, {})
    )
  }, [entries, labels, open])

  return (
    <Modal
      title="Editar conteúdo do índice"
      open={open}
      width={680}
      okText="Aplicar"
      cancelText="Cancelar"
      onCancel={onCancel}
      onOk={() => onApply(draft)}
    >
      <Alert
        type="warning"
        showIcon={false}
        message={`Máximo de 35 caracteres por item. O link é herdado do índice de conteúdo. Este artigo contém ${entries.length} seções de navegação.`}
      />
      <EntryList>
        {entries.map((entry, index) => (
          <EntryRow key={entry.key}>
            <EntryNumber>{index + 1}.</EntryNumber>
            <EntryFields>
              <Input
                value={entry.isIntroduction ? entry.title : draft[entry.key] || ''}
                disabled={entry.isIntroduction}
                maxLength={35}
                placeholder="Deixe vazio para ocultar"
                onChange={(event) =>
                  setDraft((current) => ({ ...current, [entry.key]: event.target.value }))
                }
              />
              <AnchorLabel>{entry.href}</AnchorLabel>
            </EntryFields>
          </EntryRow>
        ))}
      </EntryList>
    </Modal>
  )
}

const EntryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 24px;
`

const EntryRow = styled.div`
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
`

const EntryNumber = styled.span`
  padding-top: 8px;
  color: #122a41;
  font-weight: 600;
`

const EntryFields = styled.div`
  min-width: 0;
`

const AnchorLabel = styled.div`
  margin-top: 4px;
  color: #8b95a7;
  font-size: 12px;
  text-align: right;
`
